module.exports = __webpack_public_path__ + "static/media/ST.b9fca364.jpg";